export const FeatureCard = {
  flow: 'y', gap: 'A', padding: 'C', round: 'A', background: 'inkMid', border: '1px solid inkBorder',
  transition: 'all 0.3s cubic-bezier(0.25, 0.1, 0.25, 1)',
  ':hover': { transform: 'translateY(-4px)', boxShadow: '0 12px 40px rgba(0,0,0,0.12)' },
  CardIcon: { extends: 'Icon', icon: (el, s) => s.icon, width: 'B', height: 'B', color: '#1D1D1F' },
  CardTitle: { tag: 'h3', text: (el, s) => s.title, fontSize: 'A', fontWeight: '700', color: 'inkText', letterSpacing: '-0.01em' },
  CardDetail: { text: (el, s) => s.detail, fontSize: 'Z', color: 'inkMuted', lineHeight: '1.7' }
}
